import { Outlet } from 'react-router-dom';
import { useAxiosInterceptors } from '../hooks/useAxiosInterceptor';

export default function Root() {
    useAxiosInterceptors();

    return (
        <>
            {/* <h1>Pasta Vera - Fundraising</h1> */}
            <Outlet />
        </>
    );
}
